<app-modal [isOpen]="isOpen" title="Add New Attorney" size="lg" [showCloseButton]="false" [showCancelButton]="false" [showSubmitButton]="false" (close)="handleClose()">
    <form [formGroup]="attorneyForm" class="attorney-form">
        <div class="profile-image-section">
            <app-profile-image-upload formControlName="profile_image" [size]="100"></app-profile-image-upload>
            <div class="upload-hint">Upload Attorney Photo (Optional)</div>
        </div>

        <!-- Personal Information Section -->
        <div class="form-section">
            <h3 class="section-title">Personal Information</h3>
            <div class="form-grid">
            <!-- Attorney Name -->
            <div class="form-group">
                <label for="first_name">First Name</label>
                <input type="text" id="first_name" formControlName="first_name" placeholder="e.g. John">
                @if (getErrorMessage('first_name', 'First Name')) {
                    <div class="error-msg">
                        {{ getErrorMessage('first_name', 'First Name') }}
                    </div>
                }
            </div>

            <div class="form-group">
                <label for="last_name">Last Name</label>
                <input type="text" id="last_name" formControlName="last_name" placeholder="e.g. Doe">
                @if (getErrorMessage('last_name', 'Last Name')) {
                    <div class="error-msg">
                        {{ getErrorMessage('last_name', 'Last Name') }}
                    </div>
                }
            </div>

            <!-- Email & Phone -->
            <div class="form-group">
                <label for="attorney_email">Email Address</label>
                <input type="email" id="attorney_email" formControlName="attorney_email" placeholder="john.doe@lawfirm.com">
                @if (getErrorMessage('attorney_email', 'Email Address')) {
                    <div class="error-msg">
                        {{ getErrorMessage('attorney_email', 'Email Address') }}
                    </div>
                }
            </div>

            <div class="form-group">
                <label for="attorney_phone">Phone Number</label>
                <input type="tel" id="attorney_phone" formControlName="attorney_phone" placeholder="+1 (555) 000-0000">
                @if (getErrorMessage('attorney_phone', 'Phone Number')) {
                    <div class="error-msg">
                        {{ getErrorMessage('attorney_phone', 'Phone Number') }}
                    </div>
                }
            </div>
            </div>
        </div>

        <!-- Firm Information Section -->
        <div class="form-section">
            <h3 class="section-title">Firm & Contact Details</h3>
            <div class="form-grid">
            <!-- Firm Name & Contact Preference -->
            <div class="form-group">
                <label for="firm_name">Firm Name</label>
                <input type="text" id="firm_name" formControlName="firm_name" placeholder="ABC Legal Associates">
                @if (getErrorMessage('firm_name', 'Firm Name')) {
                    <div class="error-msg">
                        {{ getErrorMessage('firm_name', 'Firm Name') }}
                    </div>
                }
            </div>

            <div class="form-group">
                <label>Preferred Contact</label>
                <div class="radio-group">
                    <label class="radio-option">
                        <input type="radio" formControlName="preferred_contact" value="Email">
                        <span class="radio-label">Email</span>
                    </label>
                    <label class="radio-option">
                        <input type="radio" formControlName="preferred_contact" value="Phone">
                        <span class="radio-label">Phone</span>
                    </label>
                    <label class="radio-option">
                        <input type="radio" formControlName="preferred_contact" value="Mail">
                        <span class="radio-label">Mail</span>
                    </label>
                </div>
                @if (getErrorMessage('preferred_contact', 'Preferred Contact')) {
                    <div class="error-msg">
                        {{ getErrorMessage('preferred_contact', 'Preferred Contact') }}
                    </div>
                }
            </div>
            </div>
        </div>

        <!-- Address Section -->
        <div class="form-section">
            <h3 class="section-title">Firm Address</h3>
            <div class="form-grid">
            <!-- Firm Address -->
            <div class="form-group full-width">
                <label for="firm_address">Street Address</label>
                <input type="text" id="firm_address" formControlName="firm_address" placeholder="123 Business Avenue, Suite 100">
                @if (getErrorMessage('firm_address', 'Street Address')) {
                    <div class="error-msg">
                        {{ getErrorMessage('firm_address', 'Street Address') }}
                    </div>
                }
            </div>

            <div class="form-group">
                <label for="city">City</label>
                <input type="text" id="city" formControlName="city" placeholder="Miami">
                @if (getErrorMessage('city', 'City')) {
                    <div class="error-msg">
                        {{ getErrorMessage('city', 'City') }}
                    </div>
                }
            </div>

            <div class="form-group">
                <label for="state">State / Province</label>
                <input type="text" id="state" formControlName="state" placeholder="Florida">
                @if (getErrorMessage('state', 'State')) {
                    <div class="error-msg">
                        {{ getErrorMessage('state', 'State') }}
                    </div>
                }
            </div>

            <div class="form-group">
                <label for="zip_code">Zip / Postal Code</label>
                <input type="text" id="zip_code" formControlName="zip_code" placeholder="33101">
                @if (getErrorMessage('zip_code', 'Zip Code')) {
                    <div class="error-msg">
                        {{ getErrorMessage('zip_code', 'Zip Code') }}
                    </div>
                }
            </div>

            <div class="form-group">
                <label for="country">Country</label>
                <input type="text" id="country" formControlName="country" placeholder="United States">
                @if (getErrorMessage('country', 'Country')) {
                    <div class="error-msg">
                        {{ getErrorMessage('country', 'Country') }}
                    </div>
                }
            </div>
            </div>
        </div>
    </form>

    <div footer>
        <button type="button" class="btn btn-md btn-default" (click)="handleClose()">Cancel</button>
        <button type="button" class="btn btn-md btn-primary" (click)="handleSave()" [disabled]="attorneyForm.invalid">Submit</button>
    </div>
</app-modal>